var map = {
	"./components/init-components-tag.js": "../../node_modules/marko/dist/core-tags/components/init-components-tag.js",
	"./components/preferred-script-location-tag.js": "../../node_modules/marko/dist/core-tags/components/preferred-script-location-tag.js",
	"./components/preserve-tag.js": "../../node_modules/marko/dist/core-tags/components/preserve-tag.js",
	"./core/__flush_here_and_after__.js": "../../node_modules/marko/dist/core-tags/core/__flush_here_and_after__.js",
	"./core/await/AsyncValue.js": "../../node_modules/marko/dist/core-tags/core/await/AsyncValue.js",
	"./core/await/client-reorder-runtime.js": "../../node_modules/marko/dist/core-tags/core/await/client-reorder-runtime.js",
	"./core/await/renderer.js": "../../node_modules/marko/dist/core-tags/core/await/renderer.js",
	"./core/await/reorderer-renderer.js": "../../node_modules/marko/dist/core-tags/core/await/reorderer-renderer.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../../node_modules/marko/dist/core-tags sync recursive \\.(js(on)?)$";